import { create } from "zustand";
import type { ValidateUserInfoResponse } from "@/services/antiFraud.service";

interface AuthCorbanState {
  userInfo: ValidateUserInfoResponse | null;
  setUserInfo: (userInfo: ValidateUserInfoResponse) => void;
  clearUserInfo: () => void;
}

export const useAuthCorbanStore = create<AuthCorbanState>((set) => ({
  userInfo: null,
  setUserInfo: (userInfo) => set({ userInfo }),
  clearUserInfo: () => set({ userInfo: null }),
}));
